import type { Locale } from '@/types/dictionary';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import getTranslations from '@/utils/locale/getTranslations';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/X';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

const socialIcons = {
  instagram: {
    icon: InstagramIcon,
    title: 'Instagram',
  },
  linkedin: {
    icon: LinkedInIcon,
    title: 'LinkedIn',
  },
  youtube: {
    icon: YouTubeIcon,
    title: 'YouTube',
  },
  x: {
    icon: TwitterIcon,
    title: 'X',
  },
};

export default function SocialNetworks({
  locale,
  links = {},
}: {
  locale: Locale;
  links: Record<string, string>;
}) {
  const t = getTranslations({ locale });

  return (
    <Stack
      direction='column'
      spacing={0.75}
      sx={{
        maxWidth: {
          xs: '100%',
          sm: 200,
        },
      }}
    >
      <Typography variant='body1' sx={{ color: 'text.primary', fontWeight: 'bold' }}>
        {t('footer.followUs')}
      </Typography>

      <Stack direction='row' spacing={0}>
        {Object.entries(links || {}).map(([key, value]) => {
          const Icon = socialIcons[key as keyof typeof socialIcons];
          if (Icon) {
            return (
              <Tooltip key={key} title={Icon.title}>
                <IconButton href={value} size='small'>
                  <Icon.icon />
                </IconButton>
              </Tooltip>
            );
          }
        })}
      </Stack>
    </Stack>
  );
}
